<template>
  <header id="header">
    <h1>{{title}}</h1>
    <div class="menu">
      <a href title="메뉴" class="back" @click.prevent="gobackward">
        <img src="@/assets/img/back.png" alt="메뉴" />
      </a>
    </div>
  </header>
</template>

<script>
export default {
  props: ["title"],
  methods: {
    toggleGnb: function() {
      this.$store.dispatch("toggleGnb");
    },
    gobackward() {
      this.$router.go(-1);
    }
  }
};
</script>


<style lang="scss" scoped>
</style>